export default [
  {
    path: "/finance/invoice",
    name: "Invoice",
    component: () => import("@/components/invoice/InvoiceList"),
    meta: {
      title: "Finance - Invoice",
      requiresAuth: true,
      services: ["InquiryReservation"]
    }
  },
  {
    path: "/finance/invoice/receive-payment",
    name: "Invoice",
    component: () => import("@/components/invoice/ReceivePayment"),
    meta: {
      title: "Finance - Receive Payment",
      requiresAuth: true,
      services: ["InquiryReservation"]
    }
  },
  {
    path: "/finance/invoice/edit-invoice/:id",
    name: "Invoice",
    component: () => import("@/components/invoice/EditInvoice"),
    meta: {
      title: "Finance - Edit Invoice",
      requiresAuth: true,
      services: ["InquiryReservation"]
    }
  },
  {
    path: "/finance/invoice-detail/:invoice_id/:reservation_id",
    name: "Invoice",
    component: () => import("@/components/invoice/InvoiceDetail"),
    meta: {
      title: "Finance - Invoice Detail",
      requiresAuth: true,
      services: ["InquiryReservation"]
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/modules/financeModule.js